import { render, staticRenderFns } from "./PlaceEdit.vue?vue&type=template&id=418e1d36&scoped=true"
import script from "./PlaceEdit.vue?vue&type=script&lang=js"
export * from "./PlaceEdit.vue?vue&type=script&lang=js"
import style0 from "./PlaceEdit.vue?vue&type=style&index=0&id=418e1d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e1d36",
  null
  
)

export default component.exports